<template>
  <div class="mx-auto md:max-w-[960px] lg:max-w-[1300px] xl:max-w-[1400px] px-4 sm:px-8">
    <slot />
  </div>
</template>